import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import $axios from "../../api/accessories";
import { $api } from "../../api/api";
interface  translationsData {
  [key: string]: string; // Dinamik açarları və onların dəyərlərini "string" olaraq qəbul edirik.
}

interface translationsState {
  loading: boolean;
  data: translationsData;
  error: string;
}

const initialState: translationsState = {
  loading: false,
  data: {},
  error: "",
};

export const getTranslations = createAsyncThunk<translationsData>(
  "getTranslations",
  async () => {
    const response = await $axios.get($api("translations"));
    return response.data.data;
  }
);

export const getTranslationsSlice = createSlice({
  name: "translations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTranslations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTranslations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getTranslations.rejected, (state) => {
        state.loading = false;
        state.error = "data not found";
      });
  },
});

export default getTranslationsSlice.reducer;
